import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getOrganizations = state => state.omnitecOrganizations
const getCurrentOrganization = state => state.omnitecCurrentOrganization

export const selectOrganizationsFetching = state => path(['omnitecOrganizations', 'isFetching'], state)

export const selectCurrentOrganization = createSelector(
    getCurrentOrganization,
    currentOrganization => currentOrganization || ''
)

export const selectOrganizations = createSelector(getOrganizations, organizations => {
    if (!(isEmpty(organizations.entities) || isEmpty(organizations.result))) {
        const items = organizations.entities.organizations
        return items
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/omnitecSelectors/omnitecOrganizations.js